var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 54,
    viewBox: "0 0 231 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 54,
    rx: 12,
    fill: "url(#paint0_linear_462_29649)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.1367 30.416H31.5537V31.5141H40.3789C41.5614 31.5141 42.5914 32.1331 43.1368 33.0494C42.9426 31.5639 41.6755 30.416 40.1367 30.416Z",
    fill: "url(#paint1_linear_462_29649)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3493 19.9082H29.9288C28.3903 19.9082 27.1226 21.0564 26.9287 22.5419C27.4741 21.6258 28.5039 21.0066 29.6868 21.0066H33.3494V19.9082H33.3493Z",
    fill: "url(#paint2_linear_462_29649)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1363 19.9082H34.4473V21.0066H40.3782C41.5608 21.0066 42.5908 21.6258 43.1361 22.5417C42.9421 21.0562 41.675 19.9082 40.1363 19.9082Z",
    fill: "url(#paint3_linear_462_29649)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9136 39.7393H44.7773V40.8375H55.1558C56.3384 40.8375 57.3682 41.4567 57.9139 42.3726C57.7198 40.8871 56.4522 39.7393 54.9136 39.7393Z",
    fill: "url(#paint4_linear_462_29649)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9136 23.7109H44.7773V24.8092H55.1558C56.3384 24.8092 57.3682 25.4284 57.9139 26.3445C57.7198 24.859 56.4522 23.7109 54.9136 23.7109Z",
    fill: "url(#paint5_linear_462_29649)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9136 29.2324H44.7773V30.3305H55.1558C56.3384 30.3305 57.3682 30.9495 57.9139 31.8659C57.7198 30.3804 56.4522 29.2324 54.9136 29.2324Z",
    fill: "url(#paint6_linear_462_29649)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9136 34.4863H44.7773V35.5842H55.1558C56.3384 35.5842 57.3682 36.2038 57.9139 37.1198C57.7198 35.6342 56.4522 34.4863 54.9136 34.4863Z",
    fill: "#D6E0FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6301 26.4717H44.7773V27.5699H49.6301V26.4717Z",
    fill: "url(#paint7_linear_462_29649)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9135 26.4717H50.7285V27.5699H55.1556C56.3382 27.5699 57.368 28.1893 57.9137 29.1055C57.7197 27.6197 56.4521 26.4717 54.9135 26.4717Z",
    fill: "url(#paint8_linear_462_29649)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2466 31.8594H44.7773V32.9576H46.2466V31.8594Z",
    fill: "url(#paint9_linear_462_29649)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9135 31.8594H47.3447V32.9576H55.1556C56.3382 32.9576 57.368 33.5768 57.9137 34.4927C57.7197 33.0074 56.4521 31.8594 54.9135 31.8594Z",
    fill: "url(#paint10_linear_462_29649)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3445 37.1123H44.7764V38.2109H51.3445V37.1123Z",
    fill: "url(#paint11_linear_462_29649)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9131 37.1123H52.4434V38.2109H55.1552C56.3378 38.2109 57.3676 38.8299 57.9133 39.7462C57.7192 38.2608 56.4517 37.1123 54.9131 37.1123Z",
    fill: "url(#paint12_linear_462_29649)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2466 42.3662H44.7773V43.4643H46.2466V42.3662Z",
    fill: "url(#paint13_linear_462_29649)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9135 42.3662H47.3447V43.4643H55.1556C56.3382 43.4643 57.368 44.0838 57.9137 44.9999C57.7197 43.5142 56.4521 42.3662 54.9135 42.3662Z",
    fill: "#D6E0FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9124 20.9512H47.9707V22.0496H55.1547C56.3373 22.0496 57.3671 22.6686 57.9128 23.5847C57.7186 22.0992 56.451 20.9512 54.9124 20.9512Z",
    fill: "#D6E0FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8729 20.9512H44.7764V22.0496H46.8729V20.9512Z",
    fill: "url(#paint14_linear_462_29649)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2512 40.9229H29.9288C28.3903 40.9229 27.1226 42.071 26.9287 43.5564C27.4741 42.6403 28.5039 42.0209 29.6868 42.0209H32.2513L32.2512 40.9229Z",
    fill: "#D6E0FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1369 40.9229H33.3496V42.0209H40.379C41.5616 42.0209 42.5915 42.6401 43.1369 43.5564C42.9427 42.0709 41.6756 40.9229 40.1369 40.9229Z",
    fill: "#D6E0FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3473 35.6689H29.9288C28.3903 35.6689 27.1226 36.8171 26.9287 38.3028C27.4741 37.3867 28.5039 36.7675 29.6868 36.7675H36.3473V35.6689Z",
    fill: "url(#paint15_linear_462_29649)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1364 35.6689H37.4453V36.7674H40.3786C41.5612 36.7674 42.5911 37.3864 43.1365 38.3025C42.9423 36.8168 41.6752 35.6689 40.1364 35.6689Z",
    fill: "url(#paint16_linear_462_29649)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1363 25.1621H38.499V26.2602H40.3784C41.561 26.2602 42.591 26.8797 43.1364 27.7956C42.9422 26.3101 41.6751 25.1621 40.1363 25.1621Z",
    fill: "url(#paint17_linear_462_29649)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4008 25.1621H29.9288C28.3903 25.1621 27.1226 26.3103 26.9287 27.796C27.4741 26.8797 28.5039 26.2602 29.6868 26.2602H37.4008V25.1621Z",
    fill: "url(#paint18_linear_462_29649)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1367 14.5205H31.4648V15.6189H40.3788C41.5614 15.6189 42.5914 16.2378 43.1367 17.154C42.9425 15.6685 41.6755 14.5205 40.1367 14.5205Z",
    fill: "url(#paint19_linear_462_29649)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7979 11.7607H29.9288C28.3903 11.7607 27.1226 12.9089 26.9287 14.3944C27.4741 13.4783 28.5039 12.859 29.6868 12.859H35.7981V11.7607H35.7979Z",
    fill: "url(#paint20_linear_462_29649)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1367 11.7607H36.8965V12.859H40.3788C41.5614 12.859 42.5913 13.478 43.1367 14.3943C42.9425 12.9088 41.6754 11.7607 40.1367 11.7607Z",
    fill: "url(#paint21_linear_462_29649)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9136 42.3662H54.5713V43.4643H55.1557C56.3383 43.4643 57.3681 44.0838 57.9138 44.9999C57.7198 43.5142 56.4522 42.3662 54.9136 42.3662Z",
    fill: "url(#paint22_linear_462_29649)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6878 39.3943H40.3796C41.5622 39.3943 42.5922 40.0133 43.1376 40.9294C42.9435 39.4439 41.6763 38.2959 40.1375 38.2959H29.9297C28.3913 38.2959 27.1236 39.4443 26.9297 40.9297C27.4751 40.0133 28.5049 39.3943 29.6878 39.3943Z",
    fill: "url(#paint23_linear_462_29649)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6878 34.1401H40.3796C41.5622 34.1401 42.5922 34.7593 43.1376 35.6755C42.9435 34.19 41.6763 33.042 40.1375 33.042H29.9297C28.3913 33.042 27.1236 34.1902 26.9297 35.6755C27.4751 34.7596 28.5049 34.1401 29.6878 34.1401Z",
    fill: "#D6E0FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6878 28.8865H40.3796C41.5622 28.8865 42.5922 29.5057 43.1376 30.4218C42.9435 28.9361 41.6763 27.7881 40.1375 27.7881H29.9297C28.3913 27.7881 27.1236 28.9363 26.9297 30.4218C27.4751 29.5057 28.5049 28.8865 29.6878 28.8865Z",
    fill: "url(#paint24_linear_462_29649)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6878 23.6336H40.3796C41.5622 23.6336 42.5922 24.2524 43.1376 25.1687C42.9435 23.6832 41.6763 22.5352 40.1375 22.5352H29.9297C28.3913 22.5352 27.1236 23.6833 26.9297 25.1688C27.4751 24.2526 28.5049 23.6336 29.6878 23.6336Z",
    fill: "url(#paint25_linear_462_29649)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6878 18.3792H40.3796C41.5622 18.3792 42.5922 18.9985 43.1376 19.9148C42.9435 18.4293 41.6763 17.2812 40.1375 17.2812H29.9297C28.3913 17.2812 27.1236 18.4296 26.9297 19.9149C27.4751 18.9987 28.5049 18.3792 29.6878 18.3792Z",
    fill: "#D6E0FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6878 10.0984H40.3796C41.5622 10.0984 42.5922 10.7176 43.1376 11.6335C42.9435 10.148 41.6763 9 40.1375 9H29.9297C28.3913 9 27.1236 10.1482 26.9297 11.6337C27.4751 10.7178 28.5049 10.0984 29.6878 10.0984Z",
    fill: "#D6E0FF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1367 30.416H39.7949V31.5141H40.3789C41.5615 31.5141 42.5914 32.1331 43.1368 33.0494C42.9426 31.5639 41.6755 30.416 40.1367 30.416Z",
    fill: "url(#paint26_linear_462_29649)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1367 9H39.7949V10.0984H40.3789C41.5615 10.0984 42.5914 10.7176 43.1368 11.6335C42.9426 10.148 41.6755 9 40.1367 9Z",
    fill: "url(#paint27_linear_462_29649)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1367 33.042H39.7949V34.1399H40.3789C41.5615 34.1399 42.5914 34.7591 43.1368 35.6753C42.9426 34.19 41.6755 33.042 40.1367 33.042Z",
    fill: "url(#paint28_linear_462_29649)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1368 40.9294C42.9428 39.4439 41.6755 38.2959 40.1367 38.2959H39.7949V39.3942H40.3789C41.5615 39.3943 42.5914 40.0133 43.1368 40.9294Z",
    fill: "url(#paint29_linear_462_29649)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1367 35.6689H39.7949V36.7674H40.3789C41.5615 36.7674 42.5914 37.3864 43.1368 38.3025C42.9426 36.8168 41.6755 35.6689 40.1367 35.6689Z",
    fill: "url(#paint30_linear_462_29649)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1367 25.1621H39.7949V26.2602H40.3789C41.5615 26.2602 42.5914 26.8797 43.1368 27.7956C42.9426 26.3101 41.6755 25.1621 40.1367 25.1621Z",
    fill: "url(#paint31_linear_462_29649)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1367 27.7881H39.7949V28.8865H40.3789C41.5615 28.8865 42.5914 29.5057 43.1368 30.4218C42.9426 28.9361 41.6755 27.7881 40.1367 27.7881Z",
    fill: "url(#paint32_linear_462_29649)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1367 14.5205H39.7949V15.6189H40.3789C41.5615 15.6189 42.5914 16.2378 43.1368 17.154C42.9426 15.6685 41.6755 14.5205 40.1367 14.5205Z",
    fill: "url(#paint33_linear_462_29649)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1367 11.7607H39.7949V12.859H40.3789C41.5615 12.859 42.5914 13.478 43.1368 14.3943C42.9426 12.9088 41.6755 11.7607 40.1367 11.7607Z",
    fill: "url(#paint34_linear_462_29649)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1368 43.5564C42.9428 42.0709 41.6755 40.9229 40.1367 40.9229H39.7949V42.0209H40.3789C41.5615 42.0209 42.5914 42.6401 43.1368 43.5564Z",
    fill: "url(#paint35_linear_462_29649)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1367 22.5352H39.7949V23.6336H40.3789C41.5615 23.6336 42.5914 24.2524 43.1368 25.1687C42.9426 23.6832 41.6755 22.5352 40.1367 22.5352Z",
    fill: "url(#paint36_linear_462_29649)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1367 19.9082H39.7949V21.0066H40.3789C41.5615 21.0066 42.5914 21.6258 43.1368 22.5417C42.9426 21.0562 41.6755 19.9082 40.1367 19.9082Z",
    fill: "url(#paint37_linear_462_29649)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1367 17.2812H39.7949V18.3793H40.3789C41.5615 18.3793 42.5914 18.9987 43.1368 19.9149C42.9426 18.4293 41.6755 17.2812 40.1367 17.2812Z",
    fill: "url(#paint38_linear_462_29649)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9288 30.416H30.2709V31.5141H29.6866C28.504 31.5141 27.4742 32.1331 26.9287 33.0494C27.1227 31.5639 28.3903 30.416 29.9288 30.416Z",
    fill: "url(#paint39_linear_462_29649)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9288 9H30.2709V10.0984H29.6866C28.504 10.0984 27.4742 10.7176 26.9287 11.6335C27.1227 10.148 28.3903 9 29.9288 9Z",
    fill: "url(#paint40_linear_462_29649)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9288 33.042H30.2709V34.1399H29.6866C28.504 34.1399 27.4742 34.7591 26.9287 35.6753C27.1227 34.19 28.3903 33.042 29.9288 33.042Z",
    fill: "url(#paint41_linear_462_29649)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9287 40.9294C27.1227 39.4439 28.3903 38.2959 29.9288 38.2959H30.2709V39.3942H29.6866C28.504 39.3943 27.4742 40.0133 26.9287 40.9294Z",
    fill: "url(#paint42_linear_462_29649)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9288 35.6689H30.2709V36.7674H29.6866C28.504 36.7674 27.4742 37.3864 26.9287 38.3025C27.1227 36.8168 28.3903 35.6689 29.9288 35.6689Z",
    fill: "url(#paint43_linear_462_29649)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9288 25.1621H30.2709V26.2602H29.6866C28.504 26.2602 27.4742 26.8797 26.9287 27.7956C27.1227 26.3101 28.3903 25.1621 29.9288 25.1621Z",
    fill: "url(#paint44_linear_462_29649)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9288 27.7881H30.2709V28.8865H29.6866C28.504 28.8865 27.4742 29.5057 26.9287 30.4218C27.1227 28.9361 28.3903 27.7881 29.9288 27.7881Z",
    fill: "url(#paint45_linear_462_29649)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9288 14.5205H30.2709V15.6189H29.6866C28.504 15.6189 27.4742 16.2378 26.9287 17.154C27.1227 15.6685 28.3903 14.5205 29.9288 14.5205Z",
    fill: "url(#paint46_linear_462_29649)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9288 11.7607H30.2709V12.859H29.6866C28.504 12.859 27.4742 13.478 26.9287 14.3943C27.1227 12.9088 28.3903 11.7607 29.9288 11.7607Z",
    fill: "url(#paint47_linear_462_29649)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9287 43.5564C27.1227 42.0709 28.3903 40.9229 29.9288 40.9229H30.2709V42.0209H29.6866C28.504 42.0209 27.4742 42.6401 26.9287 43.5564Z",
    fill: "url(#paint48_linear_462_29649)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9288 22.5352H30.2709V23.6336H29.6866C28.504 23.6336 27.4742 24.2524 26.9287 25.1687C27.1227 23.6832 28.3903 22.5352 29.9288 22.5352Z",
    fill: "url(#paint49_linear_462_29649)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9288 19.9082H30.2709V21.0066H29.6866C28.504 21.0066 27.4742 21.6258 26.9287 22.5417C27.1227 21.0562 28.3903 19.9082 29.9288 19.9082Z",
    fill: "url(#paint50_linear_462_29649)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9288 17.2812H30.2709V18.3793H29.6866C28.504 18.3793 27.4742 18.9987 26.9287 19.9149C27.1227 18.4293 28.3903 17.2812 29.9288 17.2812Z",
    fill: "url(#paint51_linear_462_29649)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9136 20.9512H54.5713V22.0496H55.1557C56.3383 22.0496 57.3681 22.6686 57.9138 23.5847C57.7198 22.0992 56.4522 20.9512 54.9136 20.9512Z",
    fill: "url(#paint52_linear_462_29649)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9136 37.1123H54.5713V38.2109H55.1557C56.3383 38.2109 57.3681 38.8299 57.9138 39.7462C57.7198 38.2608 56.4522 37.1123 54.9136 37.1123Z",
    fill: "url(#paint53_linear_462_29649)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9136 39.7393H54.5713V40.8375H55.1557C56.3383 40.8375 57.3681 41.4567 57.9138 42.3726C57.7198 40.8871 56.4522 39.7393 54.9136 39.7393Z",
    fill: "url(#paint54_linear_462_29649)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9136 26.4717H54.5713V27.5699H55.1557C56.3383 27.5699 57.3681 28.1893 57.9138 29.1055C57.7198 27.6197 56.4522 26.4717 54.9136 26.4717Z",
    fill: "url(#paint55_linear_462_29649)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9136 23.7109H54.5713V24.8092H55.1557C56.3383 24.8092 57.3681 25.4284 57.9138 26.3445C57.7198 24.859 56.4522 23.7109 54.9136 23.7109Z",
    fill: "url(#paint56_linear_462_29649)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9136 34.4863H54.5713V35.5842H55.1557C56.3383 35.5842 57.3681 36.2038 57.9138 37.1198C57.7198 35.6342 56.4522 34.4863 54.9136 34.4863Z",
    fill: "url(#paint57_linear_462_29649)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9136 31.8594H54.5713V32.9576H55.1557C56.3383 32.9576 57.3681 33.5768 57.9138 34.4927C57.7198 33.0074 56.4522 31.8594 54.9136 31.8594Z",
    fill: "url(#paint58_linear_462_29649)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9136 29.2324H54.5713V30.3305H55.1557C56.3383 30.3305 57.3681 30.9495 57.9138 31.8659C57.7198 30.3804 56.4522 29.2324 54.9136 29.2324Z",
    fill: "url(#paint59_linear_462_29649)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1364 27.3032H14.7578C13.5752 27.3032 12.5452 27.9223 12 28.8388C12.1939 27.3529 13.4615 26.2051 15 26.2051H25.1364V27.3032Z",
    fill: "#D6E0FF"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M15 34.4863H25.1364V35.5842H14.7578C13.5752 35.5842 12.5452 36.2038 12 37.1198C12.1939 35.6342 13.4615 34.4863 15 34.4863Z",
    fill: "#D6E0FF"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M15 39.7402H25.1364V40.8385H14.7578C13.5752 40.8385 12.5452 41.4577 12 42.3736C12.1939 40.8881 13.4615 39.7402 15 39.7402Z",
    fill: "#D6E0FF"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1364 31.7256H23.0439V32.824H25.1364V31.7256Z",
    fill: "url(#paint60_linear_462_29649)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M15 31.7256H21.9453V32.824H14.7578C13.5752 32.824 12.5452 33.4429 12 34.3589C12.1939 32.8736 13.4615 31.7256 15 31.7256Z",
    fill: "url(#paint61_linear_462_29649)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1363 28.9648H19.1172V30.0631H25.1363V28.9648Z",
    fill: "url(#paint62_linear_462_29649)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M15 28.9648H18.0191V30.0631H14.7578C13.5752 30.0631 12.5452 30.6823 12 31.5982C12.1939 30.1127 13.4615 28.9648 15 28.9648Z",
    fill: "url(#paint63_linear_462_29649)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1363 37.1133H19.1172V38.2119H25.1363V37.1133Z",
    fill: "url(#paint64_linear_462_29649)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M15 37.1133H18.0191V38.2119H14.7578C13.5752 38.2119 12.5452 38.8309 12 39.7471C12.1939 38.2618 13.4615 37.1133 15 37.1133Z",
    fill: "url(#paint65_linear_462_29649)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1364 42.3662H23.0439V43.4643H25.1364V42.3662Z",
    fill: "url(#paint66_linear_462_29649)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M15 42.3662H21.9453V43.4643H14.7578C13.5752 43.4643 12.5452 44.0838 12 44.9999C12.1939 43.5142 13.4615 42.3662 15 42.3662Z",
    fill: "url(#paint67_linear_462_29649)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M15 26.2051H15.3424V27.3032H14.7578C13.5752 27.3032 12.5452 27.9223 12 28.8388C12.1939 27.3531 13.4615 26.2051 15 26.2051Z",
    fill: "url(#paint68_linear_462_29649)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M15 42.3662H15.3424V43.4643H14.7578C13.5752 43.4643 12.5452 44.0838 12 44.9999C12.1939 43.5142 13.4615 42.3662 15 42.3662Z",
    fill: "url(#paint69_linear_462_29649)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M15 31.7256H15.3424V32.824H14.7578C13.5752 32.824 12.5452 33.4429 12 34.3589C12.1939 32.8736 13.4615 31.7256 15 31.7256Z",
    fill: "url(#paint70_linear_462_29649)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M15 28.9658H15.3424V30.0641H14.7578C13.5752 30.0641 12.5452 30.6833 12 31.5992C12.1939 30.1137 13.4615 28.9658 15 28.9658Z",
    fill: "url(#paint71_linear_462_29649)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M15 39.7402H15.3424V40.8385H14.7578C13.5752 40.8385 12.5452 41.4577 12 42.3736C12.1939 40.8881 13.4615 39.7402 15 39.7402Z",
    fill: "url(#paint72_linear_462_29649)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M15 37.1123H15.3424V38.2109H14.7578C13.5752 38.2109 12.5452 38.8299 12 39.7462C12.1939 38.2608 13.4615 37.1123 15 37.1123Z",
    fill: "url(#paint73_linear_462_29649)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M15 34.4863H15.3424V35.5842H14.7578C13.5752 35.5842 12.5452 36.2038 12 37.1198C12.1939 35.6342 13.4615 34.4863 15 34.4863Z",
    fill: "url(#paint74_linear_462_29649)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3122 30.5V5.3H98.6242C101.792 5.3 104.168 5.9 105.752 7.1C107.36 8.3 108.164 9.884 108.164 11.852C108.164 13.172 107.84 14.324 107.192 15.308C106.544 16.268 105.656 17.012 104.528 17.54C103.4 18.068 102.104 18.332 100.64 18.332L101.324 16.856C102.908 16.856 104.312 17.12 105.536 17.648C106.76 18.152 107.708 18.908 108.38 19.916C109.076 20.924 109.424 22.16 109.424 23.624C109.424 25.784 108.572 27.476 106.868 28.7C105.164 29.9 102.656 30.5 99.3442 30.5H86.3122ZM92.1082 26.108H98.9122C100.424 26.108 101.564 25.868 102.332 25.388C103.124 24.884 103.52 24.092 103.52 23.012C103.52 21.956 103.124 21.176 102.332 20.672C101.564 20.144 100.424 19.88 98.9122 19.88H91.6762V15.632H97.9042C99.3202 15.632 100.4 15.392 101.144 14.912C101.912 14.408 102.296 13.652 102.296 12.644C102.296 11.66 101.912 10.928 101.144 10.448C100.4 9.944 99.3202 9.692 97.9042 9.692H92.1082V26.108ZM114.56 30.5V5.3H125.468C127.724 5.3 129.668 5.672 131.3 6.416C132.932 7.136 134.192 8.18 135.08 9.548C135.968 10.916 136.412 12.548 136.412 14.444C136.412 16.316 135.968 17.936 135.08 19.304C134.192 20.648 132.932 21.68 131.3 22.4C129.668 23.12 127.724 23.48 125.468 23.48H117.8L120.392 20.924V30.5H114.56ZM130.58 30.5L124.28 21.356H130.508L136.88 30.5H130.58ZM120.392 21.572L117.8 18.836H125.144C126.944 18.836 128.288 18.452 129.176 17.684C130.064 16.892 130.508 15.812 130.508 14.444C130.508 13.052 130.064 11.972 129.176 11.204C128.288 10.436 126.944 10.052 125.144 10.052H117.8L120.392 7.28V21.572ZM138.44 30.5L149.672 5.3H155.432L166.7 30.5H160.58L151.364 8.252H153.668L144.416 30.5H138.44ZM144.056 25.1L145.604 20.672H158.564L160.148 25.1H144.056ZM176.224 30.5L165.352 5.3H171.652L181.156 27.62H177.448L187.096 5.3H192.892L181.984 30.5H176.224ZM195.716 30.5V5.3H201.548V30.5H195.716ZM205.368 30.5L216.204 15.56V19.808L205.836 5.3H212.46L219.624 15.416L216.852 15.452L223.908 5.3H230.244L219.948 19.556V15.38L230.856 30.5H224.124L216.708 19.808H219.372L212.064 30.5H205.368Z",
    fill: "url(#paint75_linear_462_29649)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8762 48.644C92.2122 48.644 91.6002 48.54 91.0402 48.332C90.4882 48.116 90.0042 47.812 89.5882 47.42C89.1802 47.028 88.8602 46.568 88.6282 46.04C88.4042 45.512 88.2922 44.932 88.2922 44.3C88.2922 43.668 88.4042 43.088 88.6282 42.56C88.8602 42.032 89.1842 41.572 89.6002 41.18C90.0162 40.788 90.5042 40.488 91.0642 40.28C91.6242 40.064 92.2402 39.956 92.9122 39.956C93.6562 39.956 94.3242 40.08 94.9162 40.328C95.5162 40.576 96.0202 40.936 96.4282 41.408L95.1802 42.56C94.8762 42.24 94.5442 42.004 94.1842 41.852C93.8242 41.692 93.4322 41.612 93.0082 41.612C92.6002 41.612 92.2282 41.676 91.8922 41.804C91.5562 41.932 91.2642 42.116 91.0162 42.356C90.7762 42.596 90.5882 42.88 90.4522 43.208C90.3242 43.536 90.2602 43.9 90.2602 44.3C90.2602 44.692 90.3242 45.052 90.4522 45.38C90.5882 45.708 90.7762 45.996 91.0162 46.244C91.2642 46.484 91.5522 46.668 91.8802 46.796C92.2162 46.924 92.5842 46.988 92.9842 46.988C93.3682 46.988 93.7402 46.928 94.1002 46.808C94.4682 46.68 94.8242 46.468 95.1682 46.172L96.2722 47.576C95.8162 47.92 95.2842 48.184 94.6762 48.368C94.0762 48.552 93.4762 48.644 92.8762 48.644ZM94.4962 47.324V44.168H96.2722V47.576L94.4962 47.324ZM121.118 48.5V40.1H124.754C125.506 40.1 126.154 40.224 126.698 40.472C127.242 40.712 127.662 41.06 127.958 41.516C128.254 41.972 128.402 42.516 128.402 43.148C128.402 43.772 128.254 44.312 127.958 44.768C127.662 45.216 127.242 45.56 126.698 45.8C126.154 46.04 125.506 46.16 124.754 46.16H122.198L123.062 45.308V48.5H121.118ZM126.458 48.5L124.358 45.452H126.434L128.558 48.5H126.458ZM123.062 45.524L122.198 44.612H124.646C125.246 44.612 125.694 44.484 125.99 44.228C126.286 43.964 126.434 43.604 126.434 43.148C126.434 42.684 126.286 42.324 125.99 42.068C125.694 41.812 125.246 41.684 124.646 41.684H122.198L123.062 40.76V45.524ZM157.062 48.644C156.398 48.644 155.782 48.536 155.214 48.32C154.654 48.104 154.166 47.8 153.75 47.408C153.342 47.016 153.022 46.556 152.79 46.028C152.566 45.5 152.454 44.924 152.454 44.3C152.454 43.676 152.566 43.1 152.79 42.572C153.022 42.044 153.346 41.584 153.762 41.192C154.178 40.8 154.666 40.496 155.226 40.28C155.786 40.064 156.394 39.956 157.05 39.956C157.714 39.956 158.322 40.064 158.874 40.28C159.434 40.496 159.918 40.8 160.326 41.192C160.742 41.584 161.066 42.044 161.298 42.572C161.53 43.092 161.646 43.668 161.646 44.3C161.646 44.924 161.53 45.504 161.298 46.04C161.066 46.568 160.742 47.028 160.326 47.42C159.918 47.804 159.434 48.104 158.874 48.32C158.322 48.536 157.718 48.644 157.062 48.644ZM157.05 46.988C157.426 46.988 157.77 46.924 158.082 46.796C158.402 46.668 158.682 46.484 158.922 46.244C159.162 46.004 159.346 45.72 159.474 45.392C159.61 45.064 159.678 44.7 159.678 44.3C159.678 43.9 159.61 43.536 159.474 43.208C159.346 42.88 159.162 42.596 158.922 42.356C158.69 42.116 158.414 41.932 158.094 41.804C157.774 41.676 157.426 41.612 157.05 41.612C156.674 41.612 156.326 41.676 156.006 41.804C155.694 41.932 155.418 42.116 155.178 42.356C154.938 42.596 154.75 42.88 154.614 43.208C154.486 43.536 154.422 43.9 154.422 44.3C154.422 44.692 154.486 45.056 154.614 45.392C154.75 45.72 154.934 46.004 155.166 46.244C155.406 46.484 155.686 46.668 156.006 46.796C156.326 46.924 156.674 46.988 157.05 46.988ZM189.879 48.644C188.687 48.644 187.755 48.312 187.083 47.648C186.411 46.984 186.075 46.036 186.075 44.804V40.1H188.019V44.732C188.019 45.532 188.183 46.108 188.511 46.46C188.839 46.812 189.299 46.988 189.891 46.988C190.483 46.988 190.943 46.812 191.271 46.46C191.599 46.108 191.763 45.532 191.763 44.732V40.1H193.683V44.804C193.683 46.036 193.347 46.984 192.675 47.648C192.003 48.312 191.071 48.644 189.879 48.644ZM218.644 48.5V40.1H222.28C223.032 40.1 223.68 40.224 224.224 40.472C224.768 40.712 225.188 41.06 225.484 41.516C225.78 41.972 225.928 42.516 225.928 43.148C225.928 43.772 225.78 44.312 225.484 44.768C225.188 45.224 224.768 45.576 224.224 45.824C223.68 46.064 223.032 46.184 222.28 46.184H219.724L220.588 45.308V48.5H218.644ZM220.588 45.524L219.724 44.6H222.172C222.772 44.6 223.22 44.472 223.516 44.216C223.812 43.96 223.96 43.604 223.96 43.148C223.96 42.684 223.812 42.324 223.516 42.068C223.22 41.812 222.772 41.684 222.172 41.684H219.724L220.588 40.76V45.524Z",
    fill: "#041038"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_462_29649",
    x1: 35,
    y1: 16.47,
    x2: 35,
    y2: 56.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C2C8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01030F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_462_29649",
    x1: 34.6397,
    y1: 31.3515,
    x2: 43.1914,
    y2: 33.3939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_462_29649",
    x1: 28.6393,
    y1: 20.8439,
    x2: 33.5638,
    y2: 21.4957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_462_29649",
    x1: 36.7622,
    y1: 20.8438,
    x2: 43.3322,
    y2: 22.0207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_462_29649",
    x1: 48.2772,
    y1: 40.6748,
    x2: 57.8283,
    y2: 43.2617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_462_29649",
    x1: 48.2772,
    y1: 24.6465,
    x2: 57.8284,
    y2: 27.2333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_462_29649",
    x1: 48.2772,
    y1: 30.168,
    x2: 57.8284,
    y2: 32.7548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_462_29649",
    x1: 46.0702,
    y1: 26.8619,
    x2: 49.6512,
    y2: 27.7209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_462_29649",
    x1: 52.6428,
    y1: 27.4074,
    x2: 58.1298,
    y2: 28.2201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_462_29649",
    x1: 45.1688,
    y1: 32.2495,
    x2: 46.3094,
    y2: 32.3324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_462_29649",
    x1: 50.1605,
    y1: 32.7949,
    x2: 58.0347,
    y2: 34.5108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_462_29649",
    x1: 46.5263,
    y1: 37.5026,
    x2: 51.1635,
    y2: 39.0079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_462_29649",
    x1: 53.9007,
    y1: 38.048,
    x2: 58.1158,
    y2: 38.5233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_462_29649",
    x1: 45.1688,
    y1: 42.7563,
    x2: 46.3094,
    y2: 42.8392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_462_29649",
    x1: 45.3349,
    y1: 21.3414,
    x2: 46.9536,
    y2: 21.5091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_462_29649",
    x1: 29.438,
    y1: 36.6047,
    x2: 36.5213,
    y2: 37.9799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_462_29649",
    x1: 38.9616,
    y1: 36.6045,
    x2: 43.3427,
    y2: 37.1186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_462_29649",
    x1: 39.7345,
    y1: 26.0977,
    x2: 43.3207,
    y2: 26.4406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_462_29649",
    x1: 29.7187,
    y1: 26.0978,
    x2: 37.5273,
    y2: 27.7835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_462_29649",
    x1: 34.5745,
    y1: 15.4561,
    x2: 43.1847,
    y2: 17.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_462_29649",
    x1: 29.2917,
    y1: 12.6964,
    x2: 35.9895,
    y2: 13.9211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_462_29649",
    x1: 38.559,
    y1: 12.6963,
    x2: 43.3496,
    y2: 13.3127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_462_29649",
    x1: 55.4618,
    y1: 43.3019,
    x2: 58.058,
    y2: 43.4808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_462_29649",
    x1: 31.2478,
    y1: 39.2316,
    x2: 42.6263,
    y2: 43.0333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_462_29649",
    x1: 31.2478,
    y1: 28.7237,
    x2: 42.6262,
    y2: 32.5256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_462_29649",
    x1: 31.2478,
    y1: 23.4708,
    x2: 42.6262,
    y2: 27.2727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_462_29649",
    x1: 40.6853,
    y1: 31.3515,
    x2: 43.2809,
    y2: 31.5304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_462_29649",
    x1: 40.6853,
    y1: 9.93559,
    x2: 43.2809,
    y2: 10.1144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F4592"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2DCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_462_29649",
    x1: 40.6853,
    y1: 33.9775,
    x2: 43.2809,
    y2: 34.1564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F4592"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2DCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_462_29649",
    x1: 40.6853,
    y1: 39.2315,
    x2: 43.2809,
    y2: 39.4103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_462_29649",
    x1: 40.6853,
    y1: 36.6045,
    x2: 43.2809,
    y2: 36.7834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_462_29649",
    x1: 40.6853,
    y1: 26.0977,
    x2: 43.2809,
    y2: 26.2765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_462_29649",
    x1: 40.6853,
    y1: 28.7237,
    x2: 43.2809,
    y2: 28.9026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_462_29649",
    x1: 40.6853,
    y1: 15.4561,
    x2: 43.2809,
    y2: 15.6349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_462_29649",
    x1: 40.6853,
    y1: 12.6963,
    x2: 43.2809,
    y2: 12.8752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_462_29649",
    x1: 40.6853,
    y1: 41.8584,
    x2: 43.2809,
    y2: 42.0373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F4592"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2DCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_462_29649",
    x1: 40.6853,
    y1: 23.4707,
    x2: 43.2809,
    y2: 23.6496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_462_29649",
    x1: 40.6853,
    y1: 20.8438,
    x2: 43.2809,
    y2: 21.0226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_462_29649",
    x1: 40.6853,
    y1: 18.2169,
    x2: 43.2809,
    y2: 18.3957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F4592"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2DCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_462_29649",
    x1: 27.8192,
    y1: 31.3515,
    x2: 30.4151,
    y2: 31.5304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_462_29649",
    x1: 27.8192,
    y1: 9.93559,
    x2: 30.4151,
    y2: 10.1145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_462_29649",
    x1: 27.8192,
    y1: 33.9775,
    x2: 30.4151,
    y2: 34.1564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_462_29649",
    x1: 27.8192,
    y1: 39.2315,
    x2: 30.4151,
    y2: 39.4104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_462_29649",
    x1: 27.8192,
    y1: 36.6045,
    x2: 30.4151,
    y2: 36.7834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_462_29649",
    x1: 27.8192,
    y1: 26.0977,
    x2: 30.4151,
    y2: 26.2766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_462_29649",
    x1: 27.8192,
    y1: 28.7237,
    x2: 30.4151,
    y2: 28.9026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_462_29649",
    x1: 27.8192,
    y1: 15.4561,
    x2: 30.4151,
    y2: 15.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_462_29649",
    x1: 27.8192,
    y1: 12.6963,
    x2: 30.4151,
    y2: 12.8752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_462_29649",
    x1: 27.8192,
    y1: 41.8584,
    x2: 30.4151,
    y2: 42.0373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_462_29649",
    x1: 27.8192,
    y1: 23.4707,
    x2: 30.4151,
    y2: 23.6496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_462_29649",
    x1: 27.8192,
    y1: 20.8438,
    x2: 30.4151,
    y2: 21.0227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_462_29649",
    x1: 27.8192,
    y1: 18.2169,
    x2: 30.4151,
    y2: 18.3958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_462_29649",
    x1: 55.4618,
    y1: 21.8868,
    x2: 58.058,
    y2: 22.0657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_462_29649",
    x1: 55.4618,
    y1: 38.048,
    x2: 58.058,
    y2: 38.2269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_462_29649",
    x1: 55.4618,
    y1: 40.6748,
    x2: 58.058,
    y2: 40.8537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_462_29649",
    x1: 55.4618,
    y1: 27.4074,
    x2: 58.058,
    y2: 27.5863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_462_29649",
    x1: 55.4618,
    y1: 24.6465,
    x2: 58.058,
    y2: 24.8254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_462_29649",
    x1: 55.4618,
    y1: 35.4219,
    x2: 58.058,
    y2: 35.6008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_462_29649",
    x1: 55.4618,
    y1: 32.7949,
    x2: 58.058,
    y2: 32.9738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_462_29649",
    x1: 55.4618,
    y1: 30.168,
    x2: 58.058,
    y2: 30.3469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_462_29649",
    x1: 23.6014,
    y1: 32.1158,
    x2: 25.2171,
    y2: 32.2829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_462_29649",
    x1: 14.6497,
    y1: 32.6611,
    x2: 22.0978,
    y2: 34.1884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_462_29649",
    x1: 20.7208,
    y1: 29.355,
    x2: 25.0361,
    y2: 30.6391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_462_29649",
    x1: 13.6036,
    y1: 29.9004,
    x2: 18.2297,
    y2: 30.4745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_462_29649",
    x1: 20.7208,
    y1: 37.5036,
    x2: 25.0363,
    y2: 38.7873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_462_29649",
    x1: 13.6036,
    y1: 38.049,
    x2: 18.2297,
    y2: 38.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_462_29649",
    x1: 23.6014,
    y1: 42.7563,
    x2: 25.2171,
    y2: 42.9235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_462_29649",
    x1: 14.6497,
    y1: 43.3019,
    x2: 22.0979,
    y2: 44.8289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_462_29649",
    x1: 12.8905,
    y1: 27.1407,
    x2: 15.4865,
    y2: 27.3196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_462_29649",
    x1: 12.8905,
    y1: 43.3019,
    x2: 15.4865,
    y2: 43.4807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_462_29649",
    x1: 12.8905,
    y1: 32.6611,
    x2: 15.4865,
    y2: 32.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_462_29649",
    x1: 12.8905,
    y1: 29.9014,
    x2: 15.4865,
    y2: 30.0803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_462_29649",
    x1: 12.8905,
    y1: 40.6758,
    x2: 15.4865,
    y2: 40.8547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_462_29649",
    x1: 12.8905,
    y1: 38.048,
    x2: 15.4865,
    y2: 38.2269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_462_29649",
    x1: 12.8905,
    y1: 35.4219,
    x2: 15.4865,
    y2: 35.6008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_462_29649",
    x1: 157.324,
    y1: 13.125,
    x2: 157.324,
    y2: 31.5625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C2C8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01030F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/Logo_Dark.04c50a4abaa2062832b8f93658c1e50b.svg";
export { ForwardRef as ReactComponent };